import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { API_URL, NEW_API_URL } from "../../constants/Globals";
import { connect } from "react-redux";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import useDebounce from "../../hooks/useDebounce";

const GlobalSettings = ({ selNetworkId }) => {
  const [slots, setSlots] = useState([]);
  const [feedSlots, setFeedSlots] = useState([]);
  const [types] = useState([
    { value: "sequence", label: "Sequence" },
    { value: "banner_ad", label: "Banner Ad" },
    { value: "comment", label: "Comment" },
    { value: "discover_new_acc", label: "Discover New Accounts" },
    { value: "poll", label: "Poll" },
  ]);
  const [showModal, setShowModal] = useState(false);
  const [newSlotData, setNewSlotData] = useState({
    type: null,
    typeId: null,
    feedSlotId: null,
    clientId: null,
    placementNumber: null,
  });

  const currentPage = 1;
  const perPage = 20;

  const apiUrl = `${NEW_API_URL}/slot-content`;
  const feedSlotsApiUrl = `${NEW_API_URL}/feed-slots?pageNumber=1&perPage=10&sortDirection=asc&sortByColumn=created_at`;

  const fetchFeedSlots = useCallback(async () => {
    try {
      const response = await axios.get(feedSlotsApiUrl);
      setFeedSlots(response.data?.data?.rows || []);
    } catch (error) {
      console.error("Error fetching feed slots:", error);
    }
  }, [feedSlotsApiUrl]);

  useEffect(() => {
    fetchFeedSlots();
  }, [fetchFeedSlots]);

  const fetchSlots = useCallback(async () => {
    try {
      const response = await axios.get(
        `${apiUrl}?pageNumber=${currentPage}&perPage=${perPage}&feedSlotId=&sortDirection=asc&sortByColumn=createdAt`
      );
      setSlots(response.data?.data.rows || []);
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  }, [apiUrl, currentPage, perPage]);

  useEffect(() => {
    fetchSlots();
  }, [fetchSlots, currentPage]);

  const addSlot = async () => {
    try {
      if (newSlotData.id) {
        newSlotData.typeId =
          newSlotData.feedSlotId === 2 ? 0 : newSlotData.typeId;
        const response = await axios.put(
          `${apiUrl}/${newSlotData.id}`,
          newSlotData
        );
        if (response.status === 200) {
          await fetchSlots();
          setShowModal(false);
          setNewSlotData({
            type: null,
            typeId: null,
            feedSlotId: null,
            placementNumber: null,
          });
        }
      } else {
        newSlotData.feedSlotId = parseInt(newSlotData.feedSlotId);
        newSlotData.clientId = selNetworkId;
        newSlotData.typeId = newSlotData.typeId ? newSlotData.typeId : 0;
        const response = await axios.post(apiUrl, newSlotData);
        if (response.status === 201) {
          await fetchSlots();
          setShowModal(false);
          setNewSlotData({
            type: null,
            typeId: null,
            feedSlotId: null,
            placementNumber: null,
          });
        }
      }
    } catch (error) {
      console.error("Error adding or updating slot:", error);
    }
  };

  const handleSlotTypeChange = (value) => {
    const sequenceSlot = feedSlots.find((slot) => slot.type === "repeat");
    console.log("Sequence Slot:", sequenceSlot);
    console.log("feed slots:", feedSlots);
    setNewSlotData((prevData) => ({
      ...prevData,
      type: value,
      feedSlotId:
        value === "poll" ? null : sequenceSlot ? sequenceSlot.id : null,
    }));
  };

  const validateForm = () => {
    const { type, feedSlotId, placementNumber, typeId } = newSlotData;
    if (type === "poll" && feedSlotId === 1 && !typeId) return false;
    const isFormValid = type && feedSlotId && placementNumber;
    return isFormValid;
  };

  const handleFeedSlotIdChange = (value) => {
    setNewSlotData((prevData) => ({
      ...prevData,
      feedSlotId: value,
    }));
  };

  const getTypeLabel = (typeValue) => {
    const selectedType = types.find((type) => type.value === typeValue);
    return selectedType ? selectedType.label : null;
  };

  const getAvailablePlacementNumbers = () => {
    const maxNumber =
      newSlotData.type === "poll" && newSlotData.feedSlotId === 1 ? 1000 : 20;
    const usedNumbers = slots.map((slot) => slot.placementNumber);
    const availableNumbers = [];
    for (let i = 1; i <= maxNumber; i++) {
      if (!usedNumbers.includes(i)) {
        availableNumbers.push(i);
      }
    }
    return availableNumbers;
  };

  const [pollList, setPollList] = useState([]);

  const [formData, setFormData] = useState({
    searchInput: "",
  });

  const debouncedSearch = useDebounce(formData.searchInput, 1000);

  const handleDropdownSelect = (selectedPoll) => {
    setNewSlotData((prevData) => ({
      ...prevData,
      typeId: selectedPoll.id,
    }));
    setFormData((prevData) => ({
      ...prevData,
      searchInput: selectedPoll.thesis,
    }));
  };

  useEffect(() => {
    if (debouncedSearch && newSlotData.type === "poll") searchPolls();
  }, [debouncedSearch, newSlotData.type]);

  const searchPolls = () => {
    axios
      .get(
        API_URL +
          `/admin/debate/getDebates?isActive=1&perPage=5&pageNumber=1&clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&isQuestion=0`
      )
      .then(({ data }) => setPollList(data.data.rows));
  };

  const handleEditClick = async (slot) => {
    setNewSlotData({
      ...slot,
      typeId: slot.typeId || null,
      feedSlotId: slot.feedSlotId || null,
      clientId: selNetworkId,
      placementNumber: slot.placementNumber || null,
    });

    if (slot.type === "poll" && slot.typeId) {
      try {
        const response = await axios.get(
          `${API_URL}/debate/${slot.typeId}?deviceId=1`
        );
        const pollDetails = response.data.data;
        setFormData((prevData) => ({
          ...prevData,
          searchInput: pollDetails.thesis,
        }));
      } catch (error) {
        console.error("Error fetching poll details:", error);
      }
    }

    setShowModal(true);
  };

  return (
    <section>
      <h2 className="mb-4">Global Settings</h2>

      <div className="form-tabs">
        <div className="active" style={{ cursor: "pointer" }}>
          Feed Settings
        </div>
      </div>

      <div className="segment-form after-tabs">
        <div className="segment-form-body padding-s">
          <div className="slot-settings col-md-5">
            <div list={slots} className="slot-list">
              {slots.map((slot, index) => (
                <div key={slot.id} className="slot-item">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <strong className="me-3">
                      Slot {index + 1 + (currentPage - 1) * perPage}
                    </strong>
                    <div
                      className="text-primary"
                      onClick={() => handleEditClick(slot)}
                      style={{ cursor: "pointer" }}
                    >
                      Edit
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <label>
                      {(slot.feedSlotId === 1 ? "Specific" : "Repeat") +
                        " " +
                        `${getTypeLabel(slot.type)}` +
                        " at " +
                        slot.placementNumber}
                    </label>
                  </div>
                  <hr />
                </div>
              ))}
            </div>

            {slots.length < 20 && (
              <div className="add-slot mt-3">
                <div
                  className="text-primary"
                  onClick={() => {
                    setNewSlotData({
                      type: null,
                      typeId: null,
                      feedSlotId: null,
                      clientId: null,
                      placementNumber: null,
                    });
                    setShowModal(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  + Add new slot
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="addSlotModalLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addSlotModalLabel">
                  {newSlotData.id ? "Edit Slot" : "Add New Slot"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <Form.Label htmlFor="type">Content Type</Form.Label>
                <DropdownButton
                  id="type"
                  className="customDropdown w-100"
                  title={getTypeLabel(newSlotData.type) || "Select Type"}
                >
                  {types.map((type) => (
                    <Dropdown.Item
                      key={type.value}
                      onClick={() => handleSlotTypeChange(type.value)}
                      as="button"
                    >
                      {type.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>

                {newSlotData.type === "poll" && (
                  <div className="form-group mt-3">
                    <Form.Label htmlFor="feedSlot">Slot Type</Form.Label>
                    <DropdownButton
                      className="customDropdown w-100"
                      id="feedSlot"
                      title={
                        newSlotData.feedSlotId
                          ? feedSlots.find(
                              (slot) => slot.id === newSlotData.feedSlotId
                            )?.slotName
                          : "Select Feed Slot"
                      }
                    >
                      {feedSlots.map((slot) => (
                        <Dropdown.Item
                          key={slot.id}
                          onClick={() => handleFeedSlotIdChange(slot.id)}
                          as="button"
                        >
                          {slot.slotName}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </div>
                )}

                <div className="form-group mt-3">
                  <Form.Label htmlFor="placementNumber">
                    Placement Number
                  </Form.Label>
                  <DropdownButton
                    id="placementNumber"
                    className="customDropdown w-100"
                    title={
                      newSlotData.placementNumber || "Select Placement Number"
                    }
                  >
                    {getAvailablePlacementNumbers().map((number) => (
                      <Dropdown.Item
                        key={number}
                        onClick={() =>
                          setNewSlotData((prevData) => ({
                            ...prevData,
                            placementNumber: number,
                          }))
                        }
                        as="button"
                      >
                        {number}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </div>

                {newSlotData.type === "poll" &&
                  newSlotData.feedSlotId === 1 && (
                    <div className="form-group mt-3">
                      <Form.Label htmlFor="typeId">Poll</Form.Label>
                      <Form.Control
                        type="text"
                        id="typeId"
                        value={formData.searchInput}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            searchInput: e.target.value,
                          })
                        }
                        placeholder="Search Poll"
                      />
                      {formData.searchInput && (
                        <Dropdown.Menu
                          show
                          style={{ width: "100%", overflow: "hidden" }}
                        >
                          {pollList.length > 0 ? (
                            pollList.map((option, index) => (
                              <Dropdown.Item
                                key={index}
                                onClick={() => handleDropdownSelect(option)}
                              >
                                {option.thesis}
                              </Dropdown.Item>
                            ))
                          ) : (
                            <Dropdown.Item disabled>
                              No options found
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      )}
                    </div>
                  )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addSlot}
                  disabled={!validateForm()}
                >
                  {newSlotData.id ? "Save Changes" : "Save Slot"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(GlobalSettings);
